module.exports = __webpack_public_path__ + "img/pheonix-practice.cc2eb93e.png";